import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useSelector } from 'react-redux';
import Loader from '../../../components/common/Loader';

const ProfileTypes = ({ topProfileTypes }) => {
    const loading = useSelector(state => state.profileTypes.loading);

    // topProfileTypes verisinin yükleme durumunu kontrol et
    const isLoading = loading || !Array.isArray(topProfileTypes);
    const sortedProfileTypes = isLoading ? [] : [...topProfileTypes].sort((a, b) => b.ratio - a.ratio);
    return (
        <div>
            <Card className="ribbon-box border mb-lg-0 profile-card">
                {isLoading ? (
                    <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                        <Loader />
                    </CardBody>
                ) : (
                    <CardBody className="p-4">
                        <div className="ribbon ribbon-secondary round-shape">Top Profile Types</div>
                        <div className="ribbon-content text-muted mt-4">
                            {sortedProfileTypes.map(profileType => (
                                <React.Fragment key={profileType.profileId}>
                                    <p className="mb-0" style={{ fontSize: "15px" }}>
                                        {profileType.profileName}: <span style={{ color: "#2A5B82", fontSize: "16px" }}><b>{profileType.ratio.toFixed(2)}%</b></span>
                                    </p>
                                    <br />
                                </React.Fragment>
                            ))}
                        </div>
                    </CardBody>
                )}
            </Card>
        </div>
    );
}

export default ProfileTypes;
